<template>
    <b-modal v-model="show" size="lg" title="ФМ ТУЗАТИШ БИНО ТУРИ" class="cadastre-building">
        <div class="container-fluid content-wrap">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Код <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.code"
                                :class="{'is-invalid': $v.data.code.$error}"
                                @blur="$v.data.code.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.code.$error">{{$t("realEstate.validation.cadastreBuildingEdit.code")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Текст <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.name"
                                :class="{'is-invalid': $v.data.name.$error}"
                                @blur="$v.data.name.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.name.$error">{{$t("realEstate.validation.cadastreBuildingEdit.nameUz")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Текст(ru) <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.nameRu"
                                :class="{'is-invalid': $v.data.nameRu.$error}"
                                @blur="$v.data.nameRu.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.nameRu.$error">{{$t("realEstate.validation.cadastreBuildingEdit.nameRu")}}</div>
                    </div>
                    <div class="form-group">
                        <label>{{$t("realEstate.field.buildingType")}} <span class="red">*</span></label>
                        <v-select v-model="data.buildingType" label="name"
                                  :options="buildingTypes"
                                  @search:focus="initBuildingType"
                                  @search="onBuildingTypeSearch"
                                  :filterable="false"
                                  :class="{'is-invalid': $v.data.buildingType.id.$error}"
                        >
                            <template slot="option" slot-scope="option" v-if="option && option.name">
                                <div v-html="option.name"></div>
                            </template>
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                    <div class="invalid-feedback" v-if="$v.data.buildingType.id.$error">{{$t('newRealEstate.validation.buildingType')}}</div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 table-responsive">
                    <div class="table-wrapper">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th width="50px"></th>
                                    <th>Текст</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="cbf in cadastreBuildingFieldsLeft" :key="cbf.id">
                                <td>
                                    <div class="form-check">
                                        <label class="form-check-label pl-0">
                                            <input class="form-check-input" type="checkbox" v-model="cbf.checked">
                                            <span class="form-check-sign"></span>
                                        </label>
                                    </div>
                                </td>
                                <td>{{cbf.name}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-6 col-12 table-responsive">
                    <div class="table-wrapper">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th width="50px"></th>
                                <th>Текст</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="cbf in cadastreBuildingFieldsRight" :key="cbf.id">
                                <td>
                                    <div class="form-check">
                                        <label class="form-check-label pl-0">
                                            <input class="form-check-input" type="checkbox" v-model="cbf.checked">
                                            <span class="form-check-sign"></span>
                                        </label>
                                    </div>
                                </td>
                                <td>{{cbf.name}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_BUILDING_CADASTRE_BUILDING_FIX_SIZE_ADD')" @click="save" :disabled="processing">
                {{$t('action.save')}}
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="show=!show">
                {{$t('action.cancel')}}
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
    import initFilterModel from '@/shared/filter';
    import AdvancedFilter from '@/shared/filters/advancedFilter';
    import { required } from 'vuelidate/lib/validators'
    import {clone} from '@/shared/utils';

    export default {
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                filter: initFilterModel(),
                filterBuildingType: new AdvancedFilter(),
                show: false,
                processing: false,
                data: {
                    code: '',
                    name: '',
                    nameRu: '',
                    buildingType: null,
                    data: {
                      fields: []
                    }
                },
                cadastreBuildingFields: [],
                buildingTypes: []
            }
        },
        validations:{
            data:{
                code:{
                    required
                },
                name:{
                    required
                },
                nameRu: {
                    required
                },
                buildingType: {
                    id: {
                        required: required
                    }
                }
            }
        },
        computed: {
            cadastreBuildingFieldsLeft() {
                return this.cadastreBuildingFields.filter((field) => {
                    return field.alignment === 1;
                });
            },
            cadastreBuildingFieldsRight() {
                return this.cadastreBuildingFields.filter((field) => {
                    return field.alignment === 2;
                });
            },
            checkedFieldCodes() {
                const fields = [];
                this.cadastreBuildingFields.forEach((field) => {
                    if (field.checked) {
                        fields.push(field.code);
                    }
                });
                return fields;
            }
        },
        methods: {
            init(data) {
                const vm = this;
                this.filter.page.size = 10000
                this.$http.post('/cadastre/building/field/list', this.filter)
                    .then(res => {
                        vm.initBuildingType()
                        vm.initResponse(res)
                        vm.initData(data)
                    }, err => {
                       console.log(err)
                    })
            },
            initData(data) {
                if (!data) {
                    data = {}
                } else {
                    data = clone(data)
                }

                if (!data.buildingType) {
                    data.buildingType = null
                }

                if (!data.data) {
                    data.data = {
                        fields: []
                    }
                }

                let field_codes = [];
                if (data.data.fields && data.data.fields.length > 0) {
                    field_codes = data.data.fields;
                }
                this.cadastreBuildingFields.forEach((field) => {
                    field.checked = field_codes.includes(field.code);
                });
                this.data = data
            },
            initResponse(res) {
                const data = res.data;
                this.cadastreBuildingFields = data.data.map((field) => {
                    field.checked = false;
                    return field;
                })
            },
            initBuildingType() {
                const vm = this;
                this.filterBuildingType.search = null
                this.filterBuildingType.onlyParentLookUp = true

                this.$http.post('building-type/list', this.filterBuildingType)
                    .then(res => {
                        if (res.data !== "" && res.data.data.length > 0) {
                            vm.buildingTypes = res.data.data;
                            if (this.data.buildingType) {
                                let buildingType = vm.buildingTypes.filter((b) => b.code === vm.data.buildingType.code);
                                vm.data.buildingType = buildingType ? buildingType[0] : null
                            }
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            onBuildingTypeSearch(searchTxt, loading) {
                loading(true);
                this.buildingTypes = []
                this.filterBuildingType.search = searchTxt;
                this.filterBuildingType.onlyParentLookUp = true

                this.$http.post('building-type/list', this.filterBuildingType)
                    .then(res => {
                        this.buildingTypes = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            save() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;

                this.processing = true
                this.data.data.fields = this.checkedFieldCodes
                this.$http.post('cadastre/building/fix-by-size', this.data)
                    .then(res => {
                        console.log('res = ', res)
                        vm.processing = false
                        let response = res.data;
                        if (response && response.status === "SUCCESS") {
                            vm.show = false
                            this.$eventBus.$emit('cadastreBuildingFixSizeChanged', response);
                        }
                    }, err => {
                        console.log(err)
                        vm.processing = false
                    })
            }
        },
        created() {
            this.$eventBus.$on('showCadastreBuildingFixSizeEditModal', (data) => {
                this.init(data)
                this.show = true
            })
        }
    }
</script>

<style scoped>
    .content-wrap {
        min-height: 500px;
        max-height: 700px;
        overflow-y: auto;
        overflow-x: auto;
    }
</style>